/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import {
  FETCH_APPROVAL_HISTORY_REQUEST,
  FETCH_APPROVAL_HISTORY_SUCCESS,
  FETCH_APPROVAL_HISTORY_FAILURE,
} from "./ApprovalHistoryTypes";

  const initialState = {
    loading: false,
    error: "",
    approvalLogs:[]
  };
  
  const ApprovalHistoryReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_APPROVAL_HISTORY_REQUEST:
        return {
          ...state,
          loading: true,
        };
  
      case FETCH_APPROVAL_HISTORY_SUCCESS:
        return {
          loading: false,
          approvalLogs: action.payload,
           error: "",
        };
      case FETCH_APPROVAL_HISTORY_FAILURE:
        return {
          loading: false,
          approvalLogs: {},
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default ApprovalHistoryReducer;
  